import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import useGlobal from '@/composables/useGlobal'
import {
  PROFILE_PAGE_NAME
} from '@/components/pages/cabinet/routes'

export default /*@__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props, { expose: __expose }) {
  __expose();

const { $t } = useGlobal()
const router = useRouter()

const __returned__ = { $t, router, ref, get useRouter() { return useRouter }, get useGlobal() { return useGlobal }, get PROFILE_PAGE_NAME() { return PROFILE_PAGE_NAME } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})